import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SupplierActions } from './supplier.actions';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';

@Injectable({ providedIn: 'root' })
export class SupplierActionsFacade {
  private readonly _store = inject(Store);

  public loadSuppliers(buyerId: number): void {
    this._store.dispatch(SupplierActions.loadSuppliers({ buyerId }));
  }

  public updateSupplier(id: number, data: Partial<Supplier>): void {
    this._store.dispatch(SupplierActions.updateSupplier({ id, data }));
  }

  public saveSupplierAccess(data: SupplierAccessSave): void {
    this._store.dispatch(SupplierActions.saveSupplierAccess(data));
  }
}
